import { Spacing } from '@genial/design-tokens';
import React from 'react';

import {
  TableContentItemAddButton,
  TableContentItemBadge,
  TableContentItemColumn,
  TableContentItemText,
  TableContent,
  TableContentItemCaptions,
} from '../../../../../../components/TableContent';
import { CustomerBlockStatus } from '../../../../../NewApplication/Customer/components/TableItem/components/CustomerBlockStatus';
import { mapCaptions } from '../../../../utils';
import { ItemTag } from '../ItemTag';

import { ResponsiveItemCustomerProps } from '.';

export const DesktopItemTable: React.FC<ResponsiveItemCustomerProps> = ({
  item,
  isSelected,
  addCustomerToCart,
  errorTags,
  isLoadingTags,
  refresherTags,
}) => {
  return (
    <TableContent direction="row" {...(isSelected && { bg: 'backgroundlight' })}>
      <TableContentItemColumn flex={2} space={Spacing['inline.quarck']}>
        <TableContentItemText>{item.name}</TableContentItemText>
        <TableContentItemCaptions icons={mapCaptions(item)} />
      </TableContentItemColumn>
      <TableContentItemColumn>
        <TableContentItemText>{item.cpfCnpjFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn>
        <TableContentItemText>{item.accountNumber}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn>
        <TableContentItemBadge>{item.suitabilityProfileName!}</TableContentItemBadge>
      </TableContentItemColumn>
      <TableContentItemColumn>
        <CustomerBlockStatus customer={item} />
      </TableContentItemColumn>
      <TableContentItemColumn>
        <ItemTag
          data={item.tags}
          itemId={item.customerId}
          errorTags={errorTags}
          isLoadingTags={isLoadingTags}
          refresherTags={refresherTags}
        />
      </TableContentItemColumn>
      <TableContentItemColumn>
        <TableContentItemText>{item.availableBalanceFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn>
        <TableContentItemAddButton
          isDisabled={item.registrationBlocked}
          isSelected={isSelected}
          addCustomerToCart={addCustomerToCart}
        />
      </TableContentItemColumn>
    </TableContent>
  );
};
